import { createStore } from 'vuex'
import Gallery from './gallery'
import Testimonials from './testimonios'
import Ui from './ui'
import tabs from './tabs/tabs'
import Auth from './auth'
import Dashboard from './dashboard'
import Cotizacion from './catalogo'

const store = createStore({
  modules: {
    Ui,
    Gallery,
    Cotizacion,
    Testimonials,
    Dashboard,
    Auth,
    tabs
  }
})
export default store